module.exports = __webpack_public_path__ + "img/wallenius-wilhelmsen-ocean-vector-logo.7134966d.png";